export { default } from './BadgeVat';
